import {
  HiddenInput,
  HiddenInputProps,
} from "@/components/Input/HiddenInput/HiddenInput";
import { BuilderBlockProps } from "@/types";
import { FC } from "react";

type HiddenInputBlockProps = Omit<HiddenInputProps, "type"> & BuilderBlockProps;

export const HiddenInputBlock: FC<HiddenInputBlockProps> = ({
  children: _,
  attributes,
  ...props
}) => <HiddenInput type="hidden" {...attributes} {...props} />;
